import React from 'react';

const Descripcion = (props) => (
  <div className='flex flex-grow'>
    <ol className='flex flex-grow gap-2 py-4 block text-gray-700 text-sm font-light mb-2'>
      <li>Paquetes /</li>
      <li>
        {props.nombre.replace('/', '')}
        {' / '}
        desde
        {' / '}
        {props.salida}
      </li>
      <li>
        {props.pasajeros}
        {' / '}
        personas /
      </li>
      <li className='active'>Detalle</li>
    </ol>
  </div>
);

export default Descripcion;
